import React from 'react'

function Expiry() {
  return (
    <div>Expiry / Near-Expiry Alerts</div>
  )
}

export default Expiry